/**
 * @generated SignedSource<<44ed7ddeaad1fa52a71d05534d04501a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AddTab_container$data = {
  readonly scopeId?: string;
  readonly " $fragmentType": "AddTab_container";
};
export type AddTab_container$key = {
  readonly " $data"?: AddTab_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddTab_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AddTab_container",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "scopeId"
          },
          "action": "THROW",
          "path": "scopeId"
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "5c730fc8f652490d6ab22bf4e7225d95";

export default node;
